import React from 'react';
import { CONTACT_EMAIL } from './LegalPolicyContent';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-links">
        <a className="footer-link" href="/policy">Privacy Policy</a>
        <span className="footer-divider">|</span>
        <a className="footer-link" href="/terms">Terms of Service</a>
        <span className="footer-divider">|</span>
        <a className="footer-link" href={`mailto:${CONTACT_EMAIL}`}>Contact</a>
      </div>
      <div className="footer-copy">
        Copyright © 2025 Chord Analyzer
      </div>
    </footer>
  );
};

export default Footer;
